import { MapPinIcon } from "lucide-react";
import { PhoneIcon } from "lucide-react";
import './Details.css'
export default function Details(){
    return(
        <div className="details">
            <div className="detail-item">
                <span><MapPinIcon className="icon" /> Felur De Lys Farm <br />
                262 Watling Street, <br />
                Cannock, Staffordshire, <br />
                WS11 9LY</span>
            </div>
            <br />
            <div className="detail-item">
                <PhoneIcon className="icon" /> 
                <span>+44 (0)1543 398449</span>
            </div>
        </div>
    )
}